import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  USER_FORM_FIELD_NAME_LAST_NAME,
  USER_FORM_LAST_NAME_FIELD_MAX_LENGTH,
} from '../../../../User'

import { getLastNameFieldNextValue } from './LastNameField.utils'

import * as styles from '../InhabitantFormFields.module.css'

function LastNameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Inhabitant.LastNameLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getLastNameFieldNextValue}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_LAST_NAME_FIELD_MAX_LENGTH}
      name={USER_FORM_FIELD_NAME_LAST_NAME}
      placeholder={t('Inhabitant.LastNamePlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default LastNameField
